import React, { Component } from 'react';
import { Button, Col, message, Popconfirm, Row, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import { connect } from 'react-redux';

import {
  queryCancelProtection,
  queryProtectionList,
  queryProtectionRenewal,
} from '@api/xxcrm/protect';
import { getindustryList } from '@store/modules/industry_list';
import FormAddCus from './FormAddCus';
import DetailCus from './DetailCus';
import SearchForm from './FormSearch';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      addModalVisible: false,
      title: '',
      pageNo: 1,
      total: 0,
      account_info: this.props.account_info || {},
    };
  }

  componentWillMount() {
    this.name = '';
  }

  componentDidMount() {
    const { dispatch } = this.props;
    // dispatch(getAccountInfo());
    dispatch(getindustryList());
    this.loadDate(1);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.setState({
        account_info: nextProps.account_info,
      });
      this.judge(nextProps.account_info);
    }
  }

  /**
   * 依据角色判断权限
   */
  judge = accountInfo => {
    const role = accountInfo.roles;
    const permission = {};
    role.map(sign => {
      if (
        sign === '[XxSales]' ||
        sign === '[XxSalesManager]' ||
        sign === '[FinanceMenber]' ||
        sign === '[XZManager]'
      ) {
        permission.add = true;
      } else {
        permission.add = false;
      }
      return permission;
    });
  };

  loadDate = pageNo => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.name = this.name ? this.name : '';
    params.userUuid = this.userUuid ? this.userUuid : '';
    params.orgUuid = this.orgUuid ? this.orgUuid : '';
    this.setState({
      pageNo: current,
    });
    queryProtectionList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  /**
   * 续保
   */
  protectionRenewal = uuid => {
    queryProtectionRenewal(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadDate();
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 取消保护
   */
  protectionCancel = uuid => {
    queryCancelProtection(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadDate();
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  handleChange = () => {};

  hideModal = () => {
    this.setState({
      addModalVisible: false,
      detailModalVisible: false,
    });
  };

  search = condition => {
    this.name = condition.name;
    this.userUuid = condition.userUuid;
    this.loadDate(this.state.pageNo);
  };

  showModal = (type, uuid) => {
    if (type === 'add') {
      this.setState({
        addModalVisible: true,
        title: '添加保护客户',
      });
    } else if (type === 'detail') {
      this.setState({
        detailModalVisible: true,
      });
    } else if (type === 'edit') {
      this.setState({
        addModalVisible: true,
        title: '修改保护客户',
      });
    }
    this.protectUuid = uuid;
  };

  columns = () => {
    const { account_info: accountInfo } = this.state;
    return [
      {
        title: '客户名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '公司地址',
        dataIndex: 'area',
        key: 'area',
      },
      {
        title: '行业',
        dataIndex: 'industry',
        key: 'industry',
      },
      {
        title: '保护人',
        dataIndex: 'protectName',
        key: 'protectName',
      },
      {
        title: '保护时间',
        dataIndex: 'protectDate',
        key: 'protectDate',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '到期时间',
        dataIndex: 'maturityDate',
        key: 'maturityDate',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '操作',
        key: 'done',
        render: (text, record) => {
          const date = new Date();
          const time = date.getTime();
          const expireDate = parseInt(parseInt(record.maturityDate / 86400000, 10) * 86400000, 10);
          const renewalDate = parseInt((expireDate - time) / 86400000, 10);
          let canRenewal = '';
          if (renewalDate <= 5) {
            canRenewal = true;
          } else {
            canRenewal = false;
          }
          return (
            <span>
              {record.protectUser === accountInfo.userUuid ? (
                <span>
                  <a
                    className="ant-dropdown-link"
                    onClick={() => this.showModal('detail', record.uuid)}
                  >
                    查看
                  </a>
                  丨
                </span>
              ) : (
                ''
              )}
              {record.protectUser !== accountInfo.userUuid ? (
                <a
                  className="ant-dropdown-link"
                  onClick={() => this.showModal('detail', record.uuid)}
                >
                  查看
                </a>
              ) : (
                ''
              )}
              {record.protectUser === accountInfo.userUuid ? (
                <span>
                  <a
                    className="ant-dropdown-link"
                    onClick={() => this.showModal('edit', record.uuid)}
                  >
                    修改
                  </a>
                  丨
                </span>
              ) : (
                ''
              )}
              {record.isRenewal !== 1 &&
              record.protectUser === accountInfo.userUuid &&
              canRenewal ? (
                <span>
                  <Popconfirm
                    title="您确定要续保？"
                    placement="topRight"
                    overlayStyle={{ width: 200 }}
                    onConfirm={() => this.protectionRenewal(record.uuid)}
                  >
                    <a className="ant-dropdown-link">续保</a>
                  </Popconfirm>
                  丨
                </span>
              ) : (
                ''
              )}
              {record.isRenewal !== 1 &&
              record.protectUser === accountInfo.userUuid &&
              !canRenewal ? (
                <span>
                  <a className="ant-dropdown-link" style={{ color: 'gray', cursor: 'default' }}>
                    续保
                  </a>
                  丨
                </span>
              ) : (
                ''
              )}
              {record.protectUser === accountInfo.userUuid ? (
                <Popconfirm
                  title="您确定要取消保护？"
                  placement="topRight"
                  overlayStyle={{ width: 200 }}
                  onConfirm={() => this.protectionCancel(record.uuid)}
                >
                  <a className="ant-dropdown-link">取消保护</a>
                </Popconfirm>
              ) : (
                ''
              )}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, total } = this.state;

    const pagination = {
      total,
      pageSize: 15,
      current: this.state.pageNo,
      onChange: current => {
        this.loadDate(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const { addModalVisible, detailModalVisible, title } = this.state;

    return (
      <div>
        <div className="fixed-header">
          <Row
            type="flex"
            className="protect_search"
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={12}>
              {/* <Col span={20}>
                                <Input placeholder="请输入客户名称"
                                value={this.state.userName}
                                onChange={this.handleChange}
                                onPressEnter={this.search}
                                style={{width:"300px"}}
                                />
                                <Button type="primary" onClick={this.search} style={{"marginLeft":"10px"}}>搜索</Button>
                            </Col> */}
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Link to="/xianxing/protect/record">
                <Button>保护记录</Button>
              </Link>
              <Link to="/xianxing/protect/sql">
                <Button style={{ margin: '0 8px' }}>保护客户查询</Button>
              </Link>
              <Button onClick={() => this.showModal('add', '')}>添加保护客户</Button>
            </Col>
          </Row>
          <Row justify="space-between" type="flex" style={{ marginBottom: '16px' }}>
            <Col span={24}>
              <SearchForm search={this.search} />
            </Col>
          </Row>
        </div>
        <div style={{ paddingTop: '125px' }}>
          <Table
            rowKey="uuid"
            rowSelection={{}}
            columns={this.columns()}
            dataSource={data}
            pagination={pagination}
          />
        </div>
        {addModalVisible ? (
          <FormAddCus
            cancel={this.hideModal}
            title={title}
            loadDate={this.loadDate}
            protectUuid={this.protectUuid}
          />
        ) : (
          ''
        )}
        {detailModalVisible ? (
          <DetailCus cancel={this.hideModal} protectUuid={this.protectUuid} />
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default connect(state => ({
  list: state.industry_list,
  account_info: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/protect/Index.js